export const vistaOptions = [
  //Array de Opções usadas no SELECT de cadastrar apartamento
  { label: "Não Sei", value: "NAO_SEI" },
  { label: "Estacionamento", value: "ESTACIONAMENTO" },
  { label: "Mar", value: "MAR" },
  { label: "Montanha", value: "MONTANHA" },

  { label: "Piscina", value: "PISCINA" },
  { label: "Cidade", value: "CIDADE" },
];
